import {LocationRow} from '../types/MultipleLocationsFormSchema';

export function locationRowFactory(defaultValues: Partial<LocationRow>): LocationRow {
  const defaultLocationRow: LocationRow = {
    isSelected: true,
    vectorType: 'AISLE',
    number: 1,
    symbolType: 'ALPHABET',
    beginAt: '',
    vectorPosition: 1,
  };

  return {
    ...defaultLocationRow,
    ...defaultValues,
  };
}
